export const GET_GRAPHS = 'admin/get/graphs';
export const GET_ACTIVITIES = 'admin/get/actities';
export const GET_PENDING_TRANSACTIONS = 'admin/get/pending-transactions';
export const GET_USAGE_HISTORY = 'admin/get/usage-history';
export const GET_USER_TRANSACTIONS = 'admin/get/transactions';
export const DEACTIVATE_USER = 'admin/user/deactivate';